export enum ViewModes {
    gallery = 'gallery',
    summary = 'summary',
    map = 'map',
    timeline = 'timeline',
    calendar = 'calendar'
}